const LABELS = {
  TITLES: {
    REDISPATCH_SLO_PAGE: 'Importar planilha com SLO (dias) de Redespacho',
    REDISPATCH_SLO_UPLOAD_FIELD: 'Enviar planilha de Redespacho'
  }
};

export default LABELS;
